"use client";

import { useRouter, useSearchParams } from 'next/navigation';
import HomePage from "./HomePage";
import { useEffect } from 'react';



export default function Home() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const fixedUserId = searchParams.get('user');  // just in case ... expected to visit /users/[id] instead of /?user=[id]

  useEffect(() => {
    if (fixedUserId) {
      router.push(`/users/${fixedUserId}`);
    }
  }, [fixedUserId, router]);


  return (fixedUserId ? null : (
    <HomePage />
  ));
}
